function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as DialogPrimitive from '@radix-ui/react-dialog';
import classNames from 'classnames';
import React from 'react';
import { Button } from "../Button";
import { cn } from "../lib/utils";
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTrigger } from "./dialog";
export var Modal = function Modal(_ref) {
  var header = _ref.header,
    children = _ref.children,
    trigger = _ref.trigger,
    open = _ref.open,
    onOpenChange = _ref.onOpenChange,
    className = _ref.className,
    confirmButtonProps = _ref.confirmButtonProps,
    cancelButtonProps = _ref.cancelButtonProps,
    onConfirm = _ref.onConfirm,
    confirmText = _ref.confirmText,
    onCancel = _ref.onCancel,
    cancelText = _ref.cancelText,
    footer = _ref.footer,
    hiddenCloseIcon = _ref.hiddenCloseIcon,
    _onClose = _ref.onClose,
    _ref$maskClosable = _ref.maskClosable,
    maskClosable = _ref$maskClosable === void 0 ? true : _ref$maskClosable,
    footerClassName = _ref.footerClassName;
  return /*#__PURE__*/React.createElement(Dialog, {
    open: open,
    onOpenChange: onOpenChange
  }, /*#__PURE__*/React.createElement(DialogTrigger, {
    asChild: true
  }, trigger), /*#__PURE__*/React.createElement(DialogContent, {
    className: classNames('sm:w-[480px] bg-white dark:bg-popover', className),
    hiddenCloseIcon: hiddenCloseIcon,
    onClose: function onClose() {
      if (onOpenChange) {
        onOpenChange(false);
      }
      if (_onClose) {
        _onClose();
      }
    },
    onInteractOutside: function onInteractOutside(e) {
      if (!maskClosable) {
        e.preventDefault();
      }
    }
  }, header ? /*#__PURE__*/React.createElement(DialogHeader, null, header) : null, children, footer === false ? null : footer || /*#__PURE__*/React.createElement(DialogFooter, {
    className: cn('mt-[32px]', footerClassName)
  }, /*#__PURE__*/React.createElement(DialogPrimitive.Close, {
    asChild: true
  }, /*#__PURE__*/React.createElement(Button, _extends({
    className: "flex-1 border-gray-300 text-gray-600 text-md font-medium shadow-xs",
    variant: "outline",
    onClick: onCancel
  }, cancelButtonProps), cancelText || 'Cancel')), /*#__PURE__*/React.createElement(Button, _extends({
    className: "flex-1 text-md font-medium shadow-xs",
    variant: "destructive",
    onClick: onConfirm
  }, confirmButtonProps), confirmText || 'Confirm'))));
};